import get from 'lodash/get';
import {createSelector} from 'reselect';
import {createResourceSelector} from 'src/shared/utils/resource';

export const channelLineup = createResourceSelector('channelLineup');

export const channels = createSelector(
  channelLineup,
  channelLineup => get(channelLineup, 'channels', [])
);
